import Swiper, { EffectFade, Autoplay } from 'swiper';
Swiper.use([EffectFade, Autoplay]);

class JobDetailHeroSlider {
	constructor(el) {
		this.root = el;
		this.initSlider();
	}

	initSlider() {
		new Swiper(this.root.querySelector('.js-jobsHeroSliderContainer'), {
			slidesPerView: 1,
			loopAdditionalSlides: 1,
			resistanceRatio: 0,
			effect: 'fade',
			speed: 2000,
			autoplay: {
				delay: 2000,
			},
			fadeEffect: {
				crossFade: true,
			},
			grabCursor: false,
			loop: true,
			slideActiveClass: 'is-active',
		});
	}
}

Array.from(document.querySelectorAll('.js-jobDetailHeroSlider')).forEach(
	el => new JobDetailHeroSlider(el)
);
